<div class="tosRoot">
  <div class="tosBody">
    <DIV TYPE=HEADER>
	<P  ALIGN=CENTER class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><B>CUE
	AUDIO, LLC</B></FONT></FONT></P>
	<P  ALIGN=CENTER class="margin-top-08--margin-bottom-27">
	<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><B>TERMS
	OF SERVICE</B></FONT></FONT></P>
</DIV>
<P  ALIGN=JUSTIFY class="margin-top-08"><A NAME="_GoBack"></A>
<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">Last
Modified: October 3, 2019</FONT></FONT></P>
<P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">These
Terms of Service (the “Terms of Service” or “Agreement”) set
forth the terms and conditions governing the relationship between CUE
Audio, LLC (“CUE Audio”) and the customer identified in the
applicable Web Order, SO or SOW (as defined below) or other agreement
(“Customer” or “you”) relating to the services provided by
CUE Audio through the CUE Audio Platform or otherwise (the
“Services”). </FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">CUE
Audio and Customer are individually referred to as a “Party” and
collectively as the “Parties”.</FONT></FONT></P>
<OL>
	<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Services</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.</FONT></FONT></P>
	<OL>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Scope
		of Services</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Subject to the terms and conditions of this Agreement, CUE Audio
		shall provide the CUE Audio Platform services, or other CUE Audio
		development, customization, implementation and support services,
		agreed to by the Parties through the <A HREF="https://www.cueaudio.com/">www.cueaudio.com</A>
		website or the CUE Audio portal at <A HREF="https://portal.cueaudio.com/">portal.cueaudio.com</A>
		(collectively, a “Web Order”), or as set forth in a Services
		Order (“SO”), Statement of Work (“SOW”) or other agreement,
		as further described and defined in Schedule A (the “Services”).</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT COLOR="#00000a"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Platform
		Terms of Use and Privacy Policy</B></U></FONT></FONT></FONT><FONT COLOR="#00000a"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		By entering into this Agreement, Customer agrees to the CUE Audio
		Platform Terms of Use located at </FONT></FONT></FONT><A HREF="https://www.cueaudio.com/tou"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">www.cueaudio.com/tou</FONT></FONT></A><FONT COLOR="#00000a"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">
		(“Terms of Use”), and the CUE Audio Privacy Policy located at
		</FONT></FONT></FONT><A HREF="https://www.cueaudio.com/privacy"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">www.cueaudio.com/privacy</FONT></FONT></A><FONT COLOR="#00000a"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">
		(“Privacy Policy”), which are incorporated herein by reference.
		Capitalized terms not defined in this Agreement shall have the
		meaning set forth in the Terms of Use and Privacy Policy. To the
		extent the Terms of Use or Privacy Policy are inconsistent with the
		Terms of Service, the Terms of Service shall control. Customer
		shall make sure that all users of the Services, including all users
		of the CUE Audio Apps made available by Customer, agree to the
		Terms of Use and Privacy Policy.</FONT></FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Changes
		to Services</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		CUE Audio reserves the right, in its sole discretion, to make any
		changes to the Services that it deems necessary or useful to: (a)
		maintain or enhance the quality or delivery of CUE Audio's Services
		to its customers, the competitive strength of or market for CUE
		Audio's Services or the Services' cost efficiency or performance;
		or (b) to comply with applicable law.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Savings
		Clause</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		CUE Audio’s failure to perform, or delay in performing, its
		responsibilities under this Agreement (including any Web Order, SO
		or SOW) shall be excused if and to the extent that CUE Audio
		demonstrates that such non-performance or delay is caused by: (i)
		the failure of Customer or Customer personnel to perform their
		obligations under this Agreement; (ii) any act performed or omitted
		by CUE Audio or CUE Audio personnel at the request of Customer;
		(iii) any act performed by Customer or Customer personnel to the
		extent that such act was not otherwise agreed by the Parties; or
		(iv) system failure caused by a malicious third-party technical
		attack causing a sudden, unplanned increase in network activity
		above the threshold capacity of CUE Audio systems.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Third
		Party Services</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		CUE Audio may make certain third-party products or services
		available to Customer, or may make its Services available to be
		used by Customer within certain third-party products or services
		(all third-party products and services collectively referred to as
		“Third-Party Services”), for which CUE Audio makes no
		representations, warranties or indemnities and will have no other
		liability hereunder, notwithstanding anything contained in this
		Agreement. Customer’s exclusive remedy with regard to Third-Party Services shall be against the Third-Party</FONT></FONT></P>
	</OL>
	<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Access
	and Use, Customer Restrictions</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.</FONT></FONT></P>
	<OL>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Access
		and Use</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Subject to and conditioned on Customer's and its Authorized Users'
		compliance with the terms and conditions of this Agreement, CUE
		Audio hereby grants Customer a non-exclusive, non-transferable
		right to access and use the Services during the term of the
		applicable Web Order, SO, or SOW, solely for use by Authorized
		Users in accordance with the terms and conditions herein. Such use
		is limited to Customer's internal use.</FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">
		</FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">“Authorized
		User” means Customer's employees, consultants, contractors, and
		agents (i) who are authorized by Customer to access and use the
		Services under the rights granted to Customer pursuant to this
		Agreement and (ii) for whom access to the Services has been
		purchased.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Reservation
		of Rights</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Nothing in this Agreement grants any right, title or interest in or
		to (including any license under) any intellectual property rights
		in or relating to, the Services, the CUE Audio Platform, or
		third-party materials, whether expressly, by implication, estoppel
		or otherwise. All right, title and interest in and to the Services,
		the CUE Audio Platform, and third-party materials are and will
		remain with CUE Audio and the respective rights holders in the
		third-party materials.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Authorization
		Limitations and Restrictions</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Customer shall not, and shall not permit any other person to,
		access or use the Services except as expressly permitted by this
		Agreement and, in the case of Third-Party Materials, the applicable
		third-party license agreement. For purposes of clarity and without
		limiting the generality of the foregoing, Customer shall not,
		except as this Agreement expressly permits:</FONT></FONT></P>
		<OL TYPE=a>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">copy,
			modify or create derivative works or improvements of the Services;</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">rent,
			lease, lend, sell, sublicense, assign, distribute, publish,
			transfer or otherwise make available any Services to any person,
			including on or in connection with the internet or any
			time-sharing, service bureau, software as a service, cloud or
			other technology or service;</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">reverse
			engineer, disassemble, decompile, decode, adapt or otherwise
			attempt to derive or gain access to the source code of the
			Services, in whole or in part;</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">bypass
			or breach any security device or protection used by the Services
			or access or use the Services other than by an Authorized User
			through the use of his or her own then valid access credentials;</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">input,
			upload, transmit or otherwise provide to or through the Services
			or CUE Audio Platform, any information or materials that are
			unlawful or injurious, or contain, transmit or activate any
			harmful code;</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">damage,
			destroy, disrupt, disable, impair, interfere with or otherwise
			impede or harm in any manner the Services, the CUE Audio Platform
			or CUE Audio's provision of services to any third party, in whole
			or in part;</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">remove,
			delete, alter or obscure any trademarks, specifications,
			documentation, warranties or disclaimers, or any copyright,
			trademark, patent or other intellectual property or proprietary
			rights notices from any Services, including any copy thereof;</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">access
			or use the Services in any manner or for any purpose that
			infringes, misappropriates or otherwise violates any intellectual
			property right or other right of any third party or that violates
			any applicable law;</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">send
			spam or otherwise duplicative or unsolicited messages in violation
			of applicable laws;</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">send
			or store infringing, obscene, threatening, libelous, or otherwise
			unlawful, unsafe, malicious, abusive or tortious material,
			including material harmful to children or violative of third-party
			privacy rights;</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">send
			or store material containing software viruses, worms, trojan
			horses or other harmful computer code, files, scripts, agents or
			programs;</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">attempt
			to gain unauthorized access to the Service or its related systems
			or networks;</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">use
			the Services in any way that violates any applicable federal,
			state, local or international law or regulation (including,
			without limitation, any laws regarding the export of data or
			software to and from the US or other countries);</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">use
			the Services for the purpose of exploiting, harming or attempting
			to exploit or harm minors in any way by exposing them to
			inappropriate content, asking for personally identifiable
			information or otherwise;</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">engage
			in any other conduct that restricts or inhibits anyone's use or
			enjoyment of the Services, the CUE Audio Platform, or which, as
			determined by CUE Audio, may harm CUE Audio or users of the CUE
			Audio Platform or Services or expose them to liability;</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">use
			any device, software or routine that interferes with the proper
			working of the Services or the CUE Audio Platform;</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">access
			or use the Services for purposes of competitive analysis of the
			Services, the development, provision or use of a competing
			software service or product or any other purpose that is to CUE
			Audio's detriment or commercial disadvantage; or</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">otherwise
			access or use the Services beyond the scope of the authorization
			granted under this Agreement.</FONT></FONT></P>
		</OL>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><A NAME="_3dy6vkm"></A>
		<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Service
		Management</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Customer shall, throughout the Term, maintain within its
		organization a service manager to serve as the primary point of
		contact for day-to-day communications, consultation and
		decision-making regarding the Services. Each service manager shall
		be responsible for providing all day-to-day consents and approvals
		on behalf of such party under this Agreement.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Customer
		Obligations</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		In addition to any other provision of this Agreement, Customer
		shall: (i) have responsibility for the accuracy, quality, legality,
		reliability, and appropriateness of all Customer Materials (as
		defined in Section 6.2); (ii) timely supply CUE Audio with all
		necessary information and resources including, without limitation,
		all files, materials, data necessary for the Services, and access
		to information, personnel, systems and facilities, reasonably
		requested by CUE Audio (and CUE shall be entitled to rely upon any
		instructions, guidelines or information provided to CUE Audio by
		Customer); (iii) use commercially reasonable efforts to prevent
		unauthorized control or tampering or any other unauthorized access
		to, or use of, the Services; (iv) comply with all applicable laws
		(including laws regarding privacy and protection of consumer
		information) in using the Service; (v) obtain and maintain all
		computer hardware, software and communications equipment needed to
		access the Services; (vi) retain sole control over the operation,
		maintenance, and management of, and all access to and use of, the
		Customer systems, and sole responsibility for all access to and use
		of the Services.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Notice
		Regarding Photosensitive Epilepsy</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		To the extent Customer, in its use of the Services, will display or
		implement the display of flashing lights or strobe lights at a live
		event, Customer shall provide reasonable notification to all
		individuals in the area of the show that a flashing light event
		will be occurring, and that individuals who are susceptible to
		photosensitive epilepsy or other photo sensitivities should not
		participate. Customer shall defend, indemnify and hold CUE Audio
		harmless from all claims for damages relating to the use of
		flashing lights.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08">
		<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>SDK
		For</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U>
		</U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Integration
		with Customer App</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		To the extent the Services include CUE Audio providing a software
		development kit (“SDK”) to Customer to allow for integration of
		CUE Audio’s Services into Customer’s proprietary mobile app, or
		into Customer’s existing third-party mobile app (collectively the
		“Customer App”), Customer shall be solely responsible for use
		of the SDK and integration of the Services into the Customer App.
		As for a third-party Customer App, Customer shall be responsible
		for working with the third-party and app provider to perform the
		integration and shall make sure that an appropriate agreement has
		been entered into between CUE Audio and the third-party to allow
		for the integration. The SDK may not be provided to the third-party
		without CUE Audio’s prior written approval. The Services,
		including all content and materials included in the Services, that
		are integrated into the Customer App shall not be altered in any
		way by Customer or the third-party without the prior written
		approval and consent of CUE Audio, and all users of the Customer
		App must agree to CUE Audio’s Terms of Use and Privacy Policy.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Suspension
		or Termination of Services</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		CUE Audio may, directly or indirectly, through disabling technology
		or other legal means, suspend, terminate, or otherwise deny
		Customer's, any Authorized User's, or any other person's access to
		or use of all or any part of the Services, without incurring any
		resulting obligation or liability, if: (a) CUE Audio receives a
		judicial or other governmental demand or order, subpoena, or law
		enforcement request that expressly or by reasonable implication
		requires CUE Audio to do so; or (b) CUE Audio believes, in its
		discretion, that: (i) Customer or any Authorized User has failed to
		comply with any term of this Agreement, or accessed or used the
		Services beyond the scope of the rights granted or for a purpose
		not authorized under this Agreement or in any manner that does not
		comply with any instruction or requirement of CUE Audio; (ii)
		Customer or any Authorized User is, has been, or is likely to be
		involved in any fraudulent, misleading, or unlawful activities
		relating to or in connection with any of the Services; or (iii)
		this Agreement expires or is terminated. This Section does not
		limit any of CUE Audio's other rights or remedies, whether at law,
		in equity, or under this Agreement.</FONT></FONT></P>
	</OL>
	<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Data
	Backup</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
	The Services do not replace the need for Customer to maintain
	regular data backups or redundant data archives. CUE AUDIO HAS NO
	OBLIGATION OR LIABILITY FOR ANY LOSS, ALTERATION, DESTRUCTION,
	DAMAGE, CORRUPTION OR RECOVERY OF CUSTOMER DATA.</FONT></FONT></P>
	<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Security</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.</FONT></FONT></P>
	<OL>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Customer
		Control and Responsibility</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Customer has and will retain sole responsibility for: (a) all
		Customer Data, including its content and use; (b) all information,
		instructions and materials provided by or on behalf of Customer or
		any Authorized User in connection with the Services; (c) Customer's
		information technology infrastructure, including computers,
		software, databases, electronic systems (including database
		management systems) and networks, whether operated directly by
		Customer or through the use of third-party services (“Customer
		Systems”); (d) the security and use of Customer's and its
		Authorized Users' access credentials; and (e) all access to and use
		of the Services directly or indirectly by or through the Customer
		Systems or its or its Authorized Users' access credentials, with or
		without Customer’s knowledge or consent, including all results
		obtained from, and all conclusions, decisions and actions based on,
		such access or use. “Customer Data” means information, data,
		and other content, in any form or medium, that is collected,
		downloaded, or otherwise received, directly or indirectly from
		Customer or an Authorized User by or through the Services or that
		incorporates or is derived from the processing of such information,
		data, or content by or through the Services.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Access
		and Security</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Customer shall employ all physical, administrative and technical
		controls, screening and security procedures and other safeguards
		necessary to: (a) securely administer the distribution and use of
		all access credentials and protect against any unauthorized access
		to or use of the Services; and (b) control the content and use of
		Customer Data, including the uploading or other provision of
		Customer Data for processing by the Services.</FONT></FONT></P>
	</OL>
	<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Fees;
	Payment Terms</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.</FONT></FONT></P>
	<OL>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Fees</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Customer shall pay CUE Audio the fees and expenses set forth in the
		applicable Web Order, SO or SOW, or as otherwise set forth in
		Schedule B (“Fees”). All Fees are non-refundable.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Taxes</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		All Fees and other amounts payable by Customer under this Agreement
		are exclusive of taxes and similar assessments. Customer is
		responsible for all sales, use and excise taxes, and any other
		similar taxes, duties and charges of any kind imposed by any
		federal, state or local governmental or regulatory authority on any
		amounts payable by Customer hereunder, other than any taxes imposed
		on CUE Audio's income.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Payment</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.</FONT></FONT></P>
		<OL TYPE=a>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Web
			Orders/Subscription Services</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.</FONT></FONT></P>
			<OL TYPE=i>
				<LI><P  ALIGN=JUSTIFY class="margin-top-08"><A NAME="_Hlk1080028"></A>
				<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">If
				you purchase any Services through a Web Order, you agree to pay
				the applicable fees and taxes agreed to. CUE Audio’s
				subscription charges are billed according to the schedule you
				signed up for (i.e. based on the subscription start and end date,
				be it daily, monthly, quarterly, semi-annually, or annually) and
				are not refundable once they have been charged. CUE Audio does
				not issue pro-rated refunds on any unused portion of your
				subscription.</FONT></FONT></P>
				<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">A
				valid payment method, including credit card, is required to
				process the payment for your subscription Services. You shall
				provide CUE Audio with accurate and complete billing information
				including full name, address, state, zip code, telephone number,
				and valid payment method information. By submitting such payment
				information, you automatically authorize CUE Audio to charge all
				subscription Services fees incurred through your account to any
				such payment instruments. Should automatic billing fail to occur
				for any reason, CUE Audio will issue an electronic invoice
				indicating that you must proceed manually, within a certain
				deadline date, with the full payment corresponding to the billing
				period as indicated on the invoice.</FONT></FONT></P>
				<LI><P  ALIGN=JUSTIFY class="margin-top-08">
				<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">If
				you do not cancel any subscription Services prior to the end of
				the subscription Services term, the subscription Services will
				automatically renew at the current CUE Audio monthly rate and be
				automatically billed and charged to you using the payment method
				originally used to purchase the subscription Services. CUE Audio
				will provide you with a reasonable prior notice of any change in
				subscription fees to give you an opportunity to terminate your
				subscription Services before such change becomes effective. Your
				continued use of the subscription Services after the fee change
				comes into effect constitutes your agreement to pay the modified
				subscription Services fee amount.</FONT></FONT></P>
			</OL>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>SOs
			and SOWs</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
			For SOs and SOWs, CUE Audio shall issue invoices to Customer as
			set forth in the applicable SO or SOW. CUE Audio shall send
			invoices to Customer at the address set forth in the SO or SOW, or
			such other address as Customer may later specify by notice. Except
			as otherwise set forth in a SO or SOW, Customer shall pay all
			amounts due under this Agreement within 30 days after receipt of
			the applicable invoice. Payment terms shall be strictly enforced,
			and late payments shall be assessed monthly interest at the lesser
			of 1.5% and the maximum rate permitted by applicable law.</FONT></FONT></P>
		</OL>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Expenses</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Except as otherwise agreed to in an SO or SOW, Customer agrees to
		reimburse CUE for all preapproved, reasonable and necessary
		out-of-pocket expenses properly incurred or paid by CUE in
		connection with, or related to, the performance of the Services.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Late
		Payment</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Should Customer fail to make timely payments pursuant to the
		Agreement, CUE Audio may suspend further performance of any or all
		Services. If Customer fails to pay any due and payable amounts
		within 10 calendar days after receipt of CUE Audio’s written
		notice that such amounts are past due, Customer shall be deemed to
		be in material breach of this Agreement.</FONT></FONT></P>
	</OL>
	<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Intellectual
	Property Rights</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.</FONT></FONT></P>
	<OL>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Services
		and CUE Audio Materials/Customer-Specific Content</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		All right, title and interest in and to the CUE Audio Materials,
		including all Intellectual Property Rights therein, are and will
		remain with CUE Audio and, with respect to third-party materials
		included as part of Third-Party Services, the applicable
		Third-Party providers own all right, title, and interest, including
		all Intellectual Property Rights, in and to the third-party
		materials. Customer has no right, license, or authorization with
		respect to any of the CUE Audio Materials except as expressly set
		forth in this Agreement. All other rights in and to the CUE Audio
		Materials are expressly reserved by CUE Audio. “CUE Audio
		Materials” means the Services, the CUE Audio Platform,
		specifications, documentation, and CUE Audio systems and any and
		all other information, data, documents, materials, works, and other
		content, devices, methods, processes, hardware, software, and other
		technologies and inventions, including any deliverables, work
		product, technical or functional descriptions, requirements, plans,
		or reports, that are provided, created or used in connection with
		the Services or otherwise comprise or relate to the Services,
		including all data collected by the CUE Audio Platform and
		Services.</FONT></FONT><FONT FACE="Calibri, serif"> </FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">Notwithstanding
		the above, CUE Audio Materials shall not include any text, images,
		graphic designs, audio, video or other proprietary content provided
		by Customer specific to the identification, description or
		marketing of Customer products and services (“Customer-Specific
		Content”). To the extent CUE Audio obtains any rights to the
		Customer-Specific Content, CUE Audio hereby assigns to Customer all
		right, title and interest in and to the Customer-Specific Content.
		To the extent Customer obtains any rights to the CUE Audio
		Materials, Customer hereby assigns to CUE Audio all right, title
		and interest in and to CUE Audio Materials. “Intellectual
		Property Rights” means any and all registered and unregistered
		rights granted, applied for, or otherwise now or hereafter in
		existence under or related to any patent, copyright, trademark,
		trade secret, database protection, or other intellectual property
		rights laws, and all similar or equivalent rights or forms of
		protection, in any part of the world.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Customer
		Intellectual Property License</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Customer grants to CUE Audio a limited, non-exclusive, royalty-free
		right and license during the Term, with the right to use the
		Customer Materials as necessary to fulfill CUE Audio’s
		obligations under this Agreement, solely for the purpose of
		providing the Services. “Customer Materials” means trademarks,
		trade names, service marks, trade dress, designs, artwork and logos
		of Customer associated with the Services, all images, data and
		other materials provided by the Customer for the purposes of this
		Agreement, and all Customer-Specific Content and other content
		provided by Customer for posting on the CUE Audio Platform or
		through the Services.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Feedback</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		If Customer or any Authorized User transmits or provides any
		communications or materials to CUE Audio by mail, email, telephone,
		or otherwise, suggesting or recommending changes to the Services or
		CUE Audio Platform (“Feedback”), CUE Audio is free to use such
		Feedback irrespective of any other obligation or limitation between
		the parties governing such Feedback. Customer hereby assigns to CUE
		Audio on Customer's behalf, and on behalf of its employees,
		contractors and/or agents, all right, title, and interest in, and
		CUE Audio is free to use, without any attribution or compensation
		to any party, any ideas, know-how, concepts, techniques, or other
		intellectual property rights contained in the Feedback, for any
		purpose whatsoever, although CUE Audio is not required to use any
		Feedback.</FONT></FONT></P>
	</OL>
	<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Publicity</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
	Customer agrees that CUE Audio may use Customer’s business name,
	website URL and logo on its websites and in its marketing materials,
	identifying Customer as a current or former customer of CUE Audio.</FONT></FONT></P>
	<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Support</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.</FONT></FONT></P>
	<OL>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>First
		Level Customer Service</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Customer Audio will provide first level customer service to all
		Authorized Users with regard to the applicable Service, including without limitation, Authorized User
		sign-ups and cancellations, issuing Authorized User login
		information and passwords, and answering general customer service
		questions.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Second
		Level Technical Support</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		CUE Audio will provide second level technical support to the
		Customer relating to technical aspects of the CUE Audio Platform
		which will include email and phone support between the hours of 9
		am and 5 pm Mountain Time, Monday through Friday, except federal
		holidays or days on which the banks in the City of Denver, Colorado
		are closed for business. CUE Audio will provide support at no cost
		to the Customer for the first thirty (30) days from delivery of the
		Services.</FONT></FONT></P>
	</OL>
	<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Confidentiality</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
	Each Party shall (a) use Confidential Information (as defined below)
	of the other Party only for the purposes of exercising rights or
	performing obligations in connection with this Agreement; and (b)
	use at least reasonable care to protect from disclosure to any third
	parties any Confidential Information disclosed by the other Party
	(including without limitation all precautions employed by a Party
	with respect to its own Confidential Information), in each case, for
	a period commencing upon the date of disclosure until the later of
	three years after disclosure or the termination of this Agreement.
	Notwithstanding the foregoing, either Party may disclose
	Confidential Information (a) to its employees or independent
	contractors for the purpose of performing its obligations or
	exercising its rights hereunder, provided that each such employee
	and independent contractor is subject to a written agreement that
	includes binding use and disclosure restrictions that are at least
	as protective as those set forth herein; and (b) if required by law
	or a court, provided the receiving Party uses reasonable efforts to
	limit disclosure and to obtain confidential treatment or a
	protective order and allows the disclosing Party to participate in
	the proceeding. “Confidential Information” means and includes
	the terms of this Agreement and all confidential and proprietary
	information of a Party, including, without limitation, computer
	programs, software, technical drawings, algorithms, know-how, trade
	secrets, formulas, processes, ideas, inventions (whether patentable
	or not), designs, schematics and other technical, business,
	financial, customer and product information, data and development
	plans, of any nature and in any form whatsoever, provided that such
	information is marked or designated in writing as “confidential,”
	“proprietary,” or any other similar term or designation or is
	disclosed in such a manner that a reasonable person would understand
	that such information is confidential and proprietary. Customer
	agrees without limitation that CUE Audio’s prices, proposals and
	quotes related to a SO or SOW are Confidential Information of CUE
	Audio. Confidential Information does not include information that
	the receiving Party can document: (i) is or becomes (through no
	improper action or inaction by the receiving Party) readily
	available to the public; (ii) was in its possession or known by it
	without restriction on disclosure or use prior to receipt from the
	disclosing Party; (iii) was rightfully disclosed to it by a third
	party that rightfully received such information without restriction
	on disclosure or use; or (iv) was independently developed without
	use of any Confidential Information of the disclosing Party.</FONT></FONT></P>
	<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Term
	and Termination</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.</FONT></FONT></P>
	<OL>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><A NAME="_2jxsxqh"></A>
		<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Term</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Unless earlier terminated in accordance with this Agreement, this
		Agreement will continue in effect for the period set forth in the
		applicable Web Order, SO or SOW. For Web Order subscription
		Services, if you do not cancel any subscription Services prior to
		the end of the subscription Services term (you may cancel your
		subscription by logging into your account at <A HREF="https://portal.cueaudio.com">portal.cueaudio.com</A>),
		the subscription Services will automatically renew for an
		additional term equivalent to the expiring term (e.g. if the term
		was 30 days it will automatically renew for another 30 day term; if
		the term was 6 months, it will automatically renew for an
		additional 6 month term) at the then current rate for the
		applicable renewal term, and be automatically billed and charged to
		you using the payment method originally used to purchase the
		subscription Services. CUE Audio will provide you with a reasonable
		prior notice of any change in Subscription fees to give you an
		opportunity to terminate your subscription Services before such
		change becomes effective. Your continued use of the subscription
		Services after the fee change comes into effect constitutes your
		agreement to pay the modified Subscription Services fee amount.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Termination</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		In addition to any other express termination right set forth
		elsewhere in this Agreement:</FONT></FONT></P>
		<OL TYPE=a>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">either
			party may terminate this Agreement or any Web Order, SO or SOW,
			effective on written notice to the other party, if the other party
			materially breaches this Agreement or the applicable Web Order, SO
			or SOW, and such breach: (i) is incapable of cure; or (ii) being
			capable of cure, remains uncured ninety (90) days (ten (10) days
			for any failure to pay amounts due) after the non-breaching party
			provides the breaching party with written notice of such breach;
			and</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">either
			party may terminate this Agreement (and all Web Orders, SOs and
			SOWs), effective immediately upon written notice to the other
			party, if the other party: (i) becomes insolvent or is generally
			unable to pay, or fails to pay, its debts as they become due; (ii)
			files or has filed against it, a petition for voluntary or
			involuntary bankruptcy or otherwise becomes subject, voluntarily
			or involuntarily, to any proceeding under any domestic or foreign
			bankruptcy or insolvency law; (iii) makes or seeks to make a
			general assignment for the benefit of its creditors; or (iv)
			applies for or has appointed a receiver, trustee, custodian or
			similar agent appointed by order of any court of competent
			jurisdiction to take charge of or sell any material portion of its
			property or business.</FONT></FONT></P>
		</OL>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Surviving
		Terms</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Any provision or other right or obligation of the parties in this
		Agreement that, by its nature, should survive termination or
		expiration of this Agreement, will survive any expiration or
		termination of this Agreement.</FONT></FONT></P>
	</OL>
	<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Representations
	and Warranties</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.</FONT></FONT></P>
	<OL>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Mutual
		Representations and Warranties</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Each Party represents and warrants to the other Party that: (a) it
		is duly organized, validly existing and in good standing as a
		corporation or other entity under the laws of the jurisdiction of
		its incorporation or other organization; (b) it has the full right,
		power and authority to enter into and perform its obligations and
		grant the rights, licenses, consents and authorizations it grants
		or is required to grant under this Agreement; (c) the execution of
		this Agreement by its representative whose signature is set forth
		at the end of this Agreement has been duly authorized by all
		necessary corporate or organizational action of such party; and (d)
		when executed and delivered by both parties, this Agreement will
		constitute the legal, valid and binding obligation of such party,
		enforceable against such party in accordance with its terms.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Additional
		CUE Audio Warranties</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		CUE Audio represents and warrants to Customer that CUE Audio will
		perform the Services in a professional and workmanlike manner in
		accordance with generally recognized industry standards for similar
		services.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><A NAME="_4i7ojhp"></A>
		<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Additional
		Customer Representations, Warranties and Covenants</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Customer represents, warrants and covenants to CUE Audio that
		Customer owns or otherwise has and will have the necessary rights
		and consents in and relating to the Customer Materials so that, as
		received by CUE Audio and processed in accordance with this
		Agreement, they do not and will not infringe, misappropriate or
		otherwise violate any Intellectual Property Rights, or any privacy
		or other rights of any third party or violate any applicable law,
		and that it will comply with all terms and conditions of any
		agreement between Customer and the provider of Third-Party
		Services.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>DISCLAIMER
		OF WARRANTIES</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		EXCEPT FOR THE EXPRESS WARRANTIES SET FORTH IN SECTION 11.1,
		SECTION 11.2, ALL SERVICES AND CUE AUDIO MATERIALS ARE PROVIDED ON
		AN “AS IS” “WHERE IS” BASIS, AND CUE AUDIO DISCLAIMS ALL
		REPRESENTATIONS OR WARRANTIES, EXPRESS OR IMPLIED, AS TO THE
		SERVICES OR CUE AUDIO MATERIALS. CUE AUDIO SPECIFICALLY DISCLAIMS
		ALL IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
		PURPOSE, TITLE AND NON-INFRINGEMENT, AND ALL WARRANTIES ARISING
		FROM COURSE OF DEALING, USAGE OR TRADE PRACTICE. WITHOUT LIMITING
		THE FOREGOING, CUE AUDIO MAKES NO WARRANTY OF ANY KIND THAT THE
		SERVICES OR CUE AUDIO MATERIALS, OR ANY PRODUCTS OR RESULTS OF THE
		USE THEREOF, WILL MEET CUSTOMER'S OR ANY OTHER PERSON'S
		REQUIREMENTS, OPERATE WITHOUT INTERRUPTION, ACHIEVE ANY INTENDED
		RESULT, BE COMPATIBLE OR WORK WITH ANY SOFTWARE, SYSTEM OR OTHER
		SERVICES, OR BE SECURE, ACCURATE, COMPLETE, FREE OF HARMFUL CODE OR
		ERROR FREE. ALL THIRD-PARTY SERVICES AND MATERIALS ARE PROVIDED “AS
		IS”, AND ANY REPRESENTATION OR WARRANTY OF OR CONCERNING ANY
		THIRD-PARTY SERVICES OR MATERIALS IS STRICTLY BETWEEN CUSTOMER AND
		THE THIRD-PARTY OWNER OR DISTRIBUTOR OF THE THIRD-PARTY SERVICES
		AND MATERIALS.</FONT></FONT></P>
	</OL>
	<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Indemnification</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.</FONT></FONT></P>
	<OL>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>CUE
		Audio Indemnification</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Subject to the limitations of Section 13, CUE Audio shall
		indemnify, defend and hold harmless Customer from and against any
		and all losses, damages, deficiencies, claims, actions, judgments,
		settlements, interest, awards, penalties, fines, costs, or expenses
		of whatever kind, including reasonable attorneys' fees (“Losses”)
		incurred by Customer arising out of or relating to any claim, suit,
		action or proceeding (each, an “Action”) by a third party
		(other than an affiliate of Customer) that Customer's use of the
		Services (excluding Customer Materials and third party materials)
		in compliance with this Agreement infringes a U.S. Intellectual
		Property Right. The foregoing obligation does not apply to any
		Action or Losses arising out of or relating to any:</FONT></FONT></P>
		<OL TYPE=a>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">access
			to or use of the Services or CUE Audio Materials in combination
			with any hardware, system, software, network or other materials or
			service not provided or authorized in writing by CUE Audio;</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">modification
			of the Services or CUE Audio Materials other than: (i) by or on
			behalf of CUE Audio; or (ii) with CUE Audio's written approval in
			accordance with CUE Audio's written specification;</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">failure
			to timely implement any modifications, upgrades, replacements or
			enhancements made available to Customer by or on behalf of CUE
			Audio; or</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">act,
			omission or other matter described in Section 12.2.</FONT></FONT></P>
		</OL>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Customer
		Indemnification</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Customer shall indemnify, defend and hold harmless CUE Audio and
		its officers, directors, employees, agents, stockholders,
		successors and assigns (each, a “CUE Audio Indemnitee”) from
		and against any and all Losses incurred by such CUE Audio
		Indemnitee in connection with any Action by a third party that
		arise out of or relate to any: (a) Customer Materials, including
		any processing of Customer Materials by or on behalf of CUE Audio
		in accordance with this Agreement; (b) use of any Third Party
		Services, (c) allegation of facts that, if true, would constitute
		Customer's breach of any of its representations, warranties,
		covenants or obligations under this Agreement; (d) negligence or
		more culpable act or omission (including recklessness or willful
		misconduct) by Customer, any Authorized User, or any third party on
		behalf of Customer or any Authorized User, in connection with this
		Agreement; or (e) Customer’s violation or alleged violation of
		applicable law.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Exclusive
		Remedy</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		THIS SECTION 12 SETS FORTH CUSTOMER'S SOLE REMEDIES AND CUE AUDIO'S
		SOLE LIABILITY AND OBLIGATION FOR ANY ACTUAL, THREATENED OR ALLEGED
		CLAIMS THAT THIS AGREEMENT OR ANY SUBJECT MATTER HEREOF (INCLUDING
		THE SERVICES AND CUE AUDIO MATERIALS) INFRINGES, MISAPPROPRIATES OR
		OTHERWISE VIOLATES ANY THIRD-PARTY INTELLECTUAL PROPERTY RIGHT.</FONT></FONT></P>
	</OL>
	<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Limitations
	of Liability</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.</FONT></FONT></P>
	<OL>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>EXCLUSION
		OF DAMAGES</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		IN NO EVENT WILL CUE AUDIO OR ANY OF ITS LICENSORS, SERVICE
		PROVIDERS OR SUPPLIERS BE LIABLE UNDER OR IN CONNECTION WITH THIS
		AGREEMENT OR ITS SUBJECT MATTER UNDER ANY LEGAL OR EQUITABLE
		THEORY, INCLUDING BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE),
		STRICT LIABILITY AND OTHERWISE, FOR ANY: (a) LOSS OF PRODUCTION,
		USE, BUSINESS, REVENUE OR PROFIT; (b) IMPAIRMENT, INABILITY TO USE
		OR LOSS, INTERRUPTION OR DELAY OF THE SERVICES, (c) LOSS, DAMAGE,
		CORRUPTION OR RECOVERY OF DATA, OR BREACH OF DATA OR SYSTEM
		SECURITY, OR (d) CONSEQUENTIAL, INCIDENTAL, INDIRECT, EXEMPLARY,
		SPECIAL, ENHANCED OR PUNITIVE DAMAGES, REGARDLESS OF WHETHER SUCH
		PERSONS WERE ADVISED OF THE POSSIBILITY OF SUCH LOSSES OR DAMAGES
		OR SUCH LOSSES OR DAMAGES WERE OTHERWISE FORESEEABLE, AND
		NOTWITHSTANDING THE FAILURE OF ANY AGREED OR OTHER REMEDY OF ITS
		ESSENTIAL PURPOSE.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>CAP
		ON MONETARY LIABILITY</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		IN NO EVENT WILL THE AGGREGATE LIABILITY OF CUE AUDIO UNDER OR IN
		CONNECTION WITH THIS AGREEMENT OR ITS SUBJECT MATTER, UNDER ANY
		LEGAL OR EQUITABLE THEORY, INCLUDING BREACH OF CONTRACT, TORT
		(INCLUDING NEGLIGENCE), STRICT LIABILITY AND OTHERWISE, EXCEED THE
		AMOUNT PAID BY CUSTOMER TO CUE AUDIO IN THE 3 MONTHS IMMEDIATELY
		PRIOR TO THE ACTION OR CLAIM. THE FOREGOING LIMITATION APPLIES
		NOTWITHSTANDING THE FAILURE OF ANY AGREED OR OTHER REMEDY OF ITS
		ESSENTIAL PURPOSE.</FONT></FONT></P>
	</OL>
	<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Force
	Majeure</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
	Neither Party shall be liable for any default or delay in the
	performance of any of its obligations under this Agreement if and to
	the extent such default or delay is caused, directly or indirectly,
	by (a) fire, flood, earthquake, elements of nature or acts of God;
	(b) wars (declared and undeclared), acts of terrorism, sabotage,
	riots, civil disorders, rebellions or revolutions; (c) extraordinary
	malfunction of third-party Internet infrastructure, data centers or
	related systems or (d) acts of any governmental authority with
	respect to any of the foregoing, and provided that such default or
	delay cannot reasonably be circumvented by the non-performing Party
	through the use of commercially reasonable alternate sources,
	workaround plans or other commercially reasonable means.</FONT></FONT></P>
	<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Miscellaneous</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.</FONT></FONT></P>
	<OL>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Relationship
		of the Parties</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		The relationship between the parties is that of independent
		contractors. Nothing contained in this Agreement shall be construed
		as creating any agency, partnership, joint venture or other form of
		joint enterprise, employment or fiduciary relationship between the
		parties, and neither party shall have authority to contract for or
		bind the other party in any manner whatsoever.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Notices</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Any notice to be given under this Agreement shall be in writing and
		delivered by hand U.S. mail or electronic mail to the address
		listed:</FONT></FONT></P>
	</OL>
</OL>
<P  class="margin-left-25--margin-bottom-0"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">If
to CUE Audio by regular mail:	If to CUE Audio by special delivery
(FedEx/UPS):</FONT></FONT></P>
<P  class="margine-left-25--text-indent-1--margin-bottom-0">
<BR>
</P>
<P  class="margin-left-25--margin-bottom-0"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">CUE
Audio, LLC	CUE Audio, LLC<BR>PO Box 2770	157 S Main St<BR>Albany, TX
76430	Albany, TX 76430<BR>Email: <A HREF="mailto:legal@cueaudio.com">legal@cueaudio.com</A>	Email:
<A HREF="mailto:legal@cueaudio.com">legal@cueaudio.com</A></FONT></FONT></P>
<P  class="margin-left-25--margin-bottom-0"><BR>
</P>
<P  class="margin-left-25--margin-bottom-0"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">If
to Customer:</FONT></FONT><FONT FACE="Calibri, serif"> </FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">the
email or mailing address set forth in the applicable Web Order, SO or
SOW.</FONT></FONT></P>
<P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">Notices
sent in accordance with this Section will be deemed effectively
given: (a) when received, if delivered by hand, with signed
confirmation of receipt; (b) when received, if sent by a nationally
recognized overnight courier, signature required; (c) when sent, if
by e-mail, (in each case, with confirmation of transmission), if sent
during the addressee's normal business hours, and on the next
business day, if sent after the addressee's normal business hours;
and (d) on the 3</FONT></FONT><SUP><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">rd</FONT></FONT></SUP><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">
day after the date mailed by certified or registered mail, return
receipt requested, postage prepaid.</FONT></FONT></P>
<OL>
	<OL START=3>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Headings</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		The headings in this Agreement are for reference only and do not
		affect the interpretation of this Agreement.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><A NAME="_Hlk535230770"></A>
		<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Non-Solicitation/Non-Hire</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		During the term of this Agreement and any Web Order, SO or SOW, and
		for a period of one (1) year following the expiration or
		termination of this Agreement (including any Web Order, SO or SOW),
		Customer will not, directly or indirectly, (i) solicit, employ,
		offer employment to, or otherwise engage as an employee,
		independent contractor, or otherwise, any individual who is or was
		an employee of CUE Audio at any time during the term, or in any
		manner induce or attempt to induce any employee of CUE Audio to
		terminate their employment with CUE Audio, or (ii) materially
		interfere with the relationship of CUE Audio with any individual
		who at any time was an employee of CUE Audio.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Entire
		Agreement</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		This Agreement, together with the Web Order, SO, SOW and any other
		documents incorporated herein by reference, constitutes the sole
		and entire agreement of the Parties with respect to the subject
		matter of this Agreement and supersedes all prior and
		contemporaneous understandings, agreements, representations and
		warranties, both written and oral, with respect to such subject
		matter.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Assignment</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Neither Party may assign this Agreement, whether voluntarily,
		involuntarily, by merger, consolidation, dissolution, operation of
		law, or in any other manner, without the prior written consent of
		the other Party; provided, however, that, notwithstanding the
		foregoing, CUE Audio may assign this Agreement to (i) any affiliate
		or (ii) a third party by way of merger, acquisition, consolidation
		or sale or transfer of all or substantially all of its assets or
		membership units. Any purported assignment of rights in violation
		of this Section is void.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>No
		Third-Party Beneficiaries</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		This Agreement is for the sole benefit of the parties hereto and
		their respective permitted successors and permitted assigns and
		nothing herein, express or implied, is intended to or shall confer
		upon any other person any legal or equitable right, benefit or
		remedy of any nature whatsoever under or by reason of this
		Agreement.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Amendment
		and Modification; Waiver</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		Except as otherwise provided, no waiver or modification of this
		Agreement or any Web Order, SO or SOW will be binding upon either
		Party unless made in writing and signed by duly authorized
		representatives of such Party, and no failure or delay enforcing
		any right will be deemed a waiver of such right.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08">
		<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Severability</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		If any provision of this Agreement is invalid, illegal or
		unenforceable in any jurisdiction, such invalidity, illegality or
		unenforceability shall not affect any other term or provision of
		this Agreement or invalidate or render unenforceable such term or
		provision in any other jurisdiction. Upon such determination that
		any term or other provision is invalid, illegal or unenforceable,
		the parties hereto shall negotiate in good faith to modify this
		Agreement so as to effect the original intent of the parties as
		closely as possible in a mutually acceptable manner in order that
		the transactions contemplated hereby be consummated as originally
		contemplated to the greatest extent possible.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08">
		<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Governing
		Law</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		All matters relating to the Services, the CUE Audio Platform and
		this Agreement and any dispute or claim arising therefrom or
		related thereto (in each case, including non-contractual disputes
		or claims), shall be governed by and construed in accordance with
		the internal laws of the State of Colorado without giving effect to
		any choice or conflict of law provision or rule (whether of the
		State of Colorado or any other jurisdiction).</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Arbitration</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.</FONT></FONT></P>
	</OL>
</OL>
<P ALIGN=JUSTIFY class="text-indent-5--margin-top-08--line-height-100">
<FONT COLOR="#00000a"><FONT FACE="Times New Roman Bold, serif"><B><FONT COLOR="#333333"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><SPAN class="text-decoration-none">(a)
</SPAN></FONT></FONT></FONT><U><FONT COLOR="#333333"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">Scope,
Governing Rules</FONT></FONT></FONT></U></B><FONT COLOR="#333333"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><SPAN class="text-decoration-none"><SPAN class="font-weight-normal">.
The Parties agree that any controversy or claim arising out of or
relating to this Agreement, or the breach thereof, shall exclusively
be determined by final and binding arbitration administered by the
American Arbitration Association (“AAA”) under its Commercial
Arbitration Rules and Mediation Procedures (“Commercial Rules”).</SPAN></SPAN></FONT></FONT></FONT></FONT></FONT></P>
<P ALIGN=JUSTIFY class="text-indent-5--margin-top-08--line-height-100">
<FONT COLOR="#00000a"><FONT FACE="Times New Roman Bold, serif"><B><FONT COLOR="#333333"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><SPAN class="text-decoration-none">(b)
</SPAN></FONT></FONT></FONT><U><FONT COLOR="#333333"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">Authority
of Tribunal, Judicial Review</FONT></FONT></FONT></U></B><FONT COLOR="#333333"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><SPAN class="text-decoration-none"><SPAN class="font-weight-normal">.
The award rendered by the arbitrator shall be final and
non-appealable and binding on the Parties and may be entered and
enforced in any court having jurisdiction.</SPAN></SPAN></FONT></FONT></FONT></FONT></FONT></P>
<P ALIGN=JUSTIFY class="text-indent-5--margin-top-08--line-height-100">
<FONT COLOR="#00000a"><FONT FACE="Times New Roman Bold, serif"><B><FONT COLOR="#333333"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><SPAN class="text-decoration-none">(c)
</SPAN></FONT></FONT></FONT><U><FONT COLOR="#333333"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">Selection
of Tribunal</FONT></FONT></FONT></U></B><FONT COLOR="#333333"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><SPAN class="text-decoration-none"><SPAN class="font-weight-normal">.
There shall be one arbitrator agreed to by the parties within twenty
(20) days of receipt by respondent of the request for arbitration or
in default thereof appointed by the AAA in accordance with its
Commercial Rules.</SPAN></SPAN></FONT></FONT></FONT></FONT></FONT></P>
<P ALIGN=JUSTIFY class="text-indent-5--margin-top-08--line-height-100">
<FONT COLOR="#00000a"><FONT FACE="Times New Roman Bold, serif"><B><FONT COLOR="#333333"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><SPAN class="text-decoration-none">(d)
</SPAN></FONT></FONT></FONT><U><FONT COLOR="#333333"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">Seat
of Arbitration</FONT></FONT></FONT></U></B><FONT COLOR="#333333"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><SPAN class="text-decoration-none"><SPAN class="font-weight-normal">.
The seat or place of arbitration shall be Denver, Colorado, USA, and
the Parties waive any objection to arbitration taking place in
Denver.</SPAN></SPAN></FONT></FONT></FONT></FONT></FONT></P>
<OL>
	<OL>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Attorneys'
		Fees</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		In the event that any arbitration or any other action, suit, or
		other legal or administrative proceeding is instituted or commenced
		by either Party against the other party arising out of this
		Agreement, the prevailing Party shall be entitled to recover its
		reasonable attorneys' fees and costs from the non-prevailing Party.</FONT></FONT></P>
	</OL>
	<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Changes
	to the Terms of Service</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
	CUE Audio may revise and update the Terms of Service from time to
	time in its sole discretion. All changes are effective immediately
	when CUE Audio posts them and apply to all access to and use of the
	CUE Audio Services thereafter; however, any changes to the dispute
	resolution provisions set forth in the Governing Law and
	Jurisdiction section will not apply to any disputes for which the
	parties have actual notice on or prior to the date the change is
	posted on the CUE Audio Platform. Your continued use of the CUE
	Audio Services following the posting of revised Terms of Service
	means that you accept and agree to the changes. You are expected to
	check this page frequently, so you are aware of any changes, as they
	are binding on you.</FONT></FONT></P>
</OL>
<P  ALIGN=JUSTIFY class="margin-bottom-0"><BR>
</P>
<OL>
	<LI><P  ALIGN=JUSTIFY class="margin-top-08"><A NAME="_Hlk1080162"></A>
	<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>
	Engagement Services.</B></U></FONT></FONT></P>
	<OL>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><A NAME="_Hlk1080180"></A>
		<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>General</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		CUE Audio’s Engagement Services are provided by means of
		Customer sending data over audio from Customer’s speaker system
		to event attendees’ mobile devices via an audio file created by
		Customer. When Customer plays the audio file at the event in
		accordance with any instructions given by CUE Audio, the
		Engagement Services will be triggered on the mobile devices of
		event attendees using either, as applicable, the CUE Audio “CUE
		Live” app (available from the Apple App Store or Google Play
		Store), a stand-alone version of the CUE Live app customized for
		Customer (“Customized Stand-Alone App”),  or a Customer App
		that has integrated CUE Audio’s technology (a “Customer App”)
		(for purposes of this Schedule A, the CUE Live app, the Customized
		Stand-Alone App, and the Customer App are collectively referred to
		as  the “App”).</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><A NAME="_Hlk1079920"></A>
		<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Requirements
		for Use</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
		In addition to any other requirements, in order for the
		Engagement Services to work on the App, the following needs to
		occur:</FONT></FONT></P>
		<OL TYPE=a>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><A NAME="_Hlk1079886"></A>
			<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">Event
			attendees must: (i) have the App installed on their mobile devices
			with the latest updates; (ii) accept the CUE Audio Terms of Use
			and Privacy Policy; (iii) enable the App’s use of the
			microphone; (iv) have the App open in the foreground; and (v) be
			in range of the Customer’s speaker when the trigger is played.</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><A NAME="_Hlk1080537"></A>
			<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">Customer’s
			speaker system must provide adequate volume and range for the
			event attendees’ mobile devices to hear the trigger in order to
			participate.</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">Customer
			must play the trigger in accordance with any instructions provided
			by CUE Audio.</FONT></FONT></P>
		</OL>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>
		Engagement Services Available</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.</FONT></FONT></P>
		<OL TYPE=a>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><A NAME="_Hlk536285541"></A>
			<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Light
			Show</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
			Using the CUE Audio portal located at <A HREF="https://portal.cueaudio.com">portal.cueaudio.com</A>
			(the “Customer Portal”), Customer will be able to create a
			file that will allow Customer to put on a customized light show
			using attendees' mobile devices through the attendees’ use of
			the applicable App. Using audio files provided by Customer, or
			standard CUE Audio files, Customer will be able to design one
			lighting sequence (up to 2 ½ minutes in length) with both LED and
			on-screen content (the “Light Show”). All audio files, images,
			icons and content provided by Customer must be in compliance with
			the terms of the Agreement, must be correctly sized with
			appropriate ratios upon delivery to CUE Audio, and otherwise meet
			the requirements of CUE Audio. Upon completion of Customer’s
			Light Show design, Customer will be provided with an audio file
			that can be played at the event to trigger the Light Show Services
			on event attendees’ Apps. While Customer may be able to make
			some updates to on-screen content of the Light Show through the
			Customer Portal, additional audio files and lighting sequence
			design will require an additional agreement with CUE Audio and
			additional fees. Sponsor incorporation and Apple Wallet PKPass
			coupon files for distribution to attendees following the Light Show may
			also be added for an additional fee.</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Live
			Mode</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
			Using the Customer Portal, Customer will be able to design and
			create a single trigger (or set of triggers) that will cause
			attendees’ mobile devices to react with a specific response
			(“Live Mode”). Responses can include playing a sound effect or
			various flash types such as turning on or off the torch, a strobe
			effect, or displaying a specific color or image on the mobile
			device’s screen. Upon creation of the Live Mode design, Customer
			will be provided with an audio file that can be played at the
			event to trigger the response via Live Mode on event attendees’
			open Apps. Live Mode differs from a Light Show in that it is just
			one element that can be triggered on cue rather than as part of a
			longer sequence.</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><A NAME="_Hlk536286375"></A>
			<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Selfie
			Cam</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
			Using the Customer Portal, Customer will be able to select a
			pre-existing CUE Audio filter or create a new filter in accordance
			with the terms of the Agreement and the requirements of CUE Audio,
			that will allow Customer to engage event attendees by
			orchestrating a massive synchronized selfie through the App (the
			“Selfie Cam”). All files, images, icons and content provided
			by Customer must be in compliance with the terms of the Agreement,
			must be correctly sized with appropriate ratios upon delivery to
			CUE Audio, and otherwise meet the requirements of CUE Audio. Upon
			creation of the Selfie Cam Services design, Customer will be
			provided with an audio file that can be played at the event to
			trigger the synchronized Selfie Cam Services on event attendees’
			open Apps. Event attendees must provide the App with access to the
			camera for the synchronized Selfie Cam Services to work. Taking,
			posting and uploading of the selfie is at the sole discretion of
			the App user.</FONT></FONT></P>
			<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Trivia</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
			Using the Customer Portal, Customer will be able to design and
			create a synchronized interactive trivia game that allows the App
			users at the event, if they so desire, to simultaneously duel as
			they answer custom multiple-choice questions created by Customer
			(“Trivia”).</FONT></FONT> <FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">All
			files, images, icons and content provided by Customer must be in
			compliance with the terms of the Agreement, must be correctly
			sized with appropriate ratios upon delivery to CUE Audio, and
			otherwise meet the requirements of CUE Audio. Upon creation of the
			synchronized Trivia Services design, Customer will be provided
			with an audio file that can be played at the event to trigger the
			synchronized Trivia Services on event attendees’ Apps.</FONT></FONT></P>
		</OL>
	</OL>
</OL>
<OL>
	<OL>
		<OL TYPE=a>
			<OL TYPE=i>
				<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Inclusions</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
				Except as otherwise agreed, the Trivia Services will allow
				Customer to create up to twelve (12) trivia questions. At the end
				of the trivia game session, the App will provide rankings and
				send Customer a list of participants who submit their
				information. If included in the Trivia Services, Customer can
				reward the winner(s) with Apple Wallet / Google Pay coupons or
				other prizes.</FONT></FONT></P>
				<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Requirements</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
				All creation of the Trivia Services file must be in accordance
				with the terms of this Agreement and the requirements and
				instructions of CUE Audio, including the following:</FONT></FONT></P>
			</OL>
		</OL>
	</OL>
</OL>
<UL>
	<LI><P class="margin-bottom-0"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">Customer
	will provide questions with four multiple-choice answers to be used
	in the game;</FONT></FONT></P>
	<LI><P ALIGN=JUSTIFY class="margin-bottom-0"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">Questions
	are limited to six rows of text with 23 characters per row;</FONT></FONT></P>
	<LI><P ALIGN=JUSTIFY class="margin-bottom-0"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">Answers
	are limited to 25 characters;</FONT></FONT></P>
	<LI><P ALIGN=JUSTIFY class="margin-bottom-0"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">A
	minimum of 10 players is required to perform the ranking and provide
	email notification of the winner(s);</FONT></FONT></P>
	<LI><P ALIGN=JUSTIFY class="margin-bottom-0"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">Customer
	can only play the audio file once per Trivia game as multiple
	broadcasts of the trigger will result in a loss of synchronization
	and will invalidate the ranking and results provided.</FONT></FONT></P>
</UL>
<OL START=2>
	<LI><P  ALIGN=JUSTIFY class="margin-top-08"><A NAME="_Hlk536026792"></A>
	<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Customized
	CUE Live App</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
	CUE Audio will create a customized stand-alone version of the CUE
	Live App (the “Customized Stand-Alone App”) for publication and
	download via the Apple App Store and Google Play store. Creation and
	customization will be as set forth in this Agreement and the
	requirements and options provided for by CUE Audio including those
	set forth</FONT></FONT> at
	<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><A HREF="https://cueaudio-toolkit.s3.amazonaws.com/images/CUEAudioRequestList.pdf">https://cueaudio-toolkit.s3.amazonaws.com/images/CUEAudioRequestList.pdf</A>,
	and will require the timely provision of content and materials by
	Customer.</FONT></FONT> <FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">Publication
	of the App is subject to the approval process and timeline of Apple
	and Google. It will normally take 1-2 weeks after all necessary
	information, data and content is provided by Customer for the
	Customized Stand-Alone App to be published and available for
	download.</FONT></FONT></P>
	<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Customized
	CUE Live App Software Development Kit (SDK</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U>)</U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.</FONT></FONT></P>
	<OL>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">CUE
		Audio will develop and provide an SDK that can be used by Customer
		or Customer’s third-party app provider to integrate certain
		functionality of the CUE Live App, customized for Customer, into
		the Customer App. The creation of the SDK will be as set forth in
		this Agreement and the requirements and options provided for by CUE
		Audio including those set forth at
		<A HREF="https://cueaudio-toolkit.s3.amazonaws.com/images/CUEAudioRequestList-SDK.pdf">https://cueaudio-toolkit.s3.amazonaws.com/images/CUEAudioRequestList-SDK.pdf</A>,
		and will require the timely provision of content and materials by
		Customer. The Customer App must be compatible with the iOS or
		Android mobile operating systems and must contain the latest
		version and updates provided by CUE Audio, for the integration to
		work.</FONT></FONT></P>
		<LI><P  ALIGN=JUSTIFY class="margin-top-08"><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">The
		SDK will normally be created and provided within 1-2 weeks after
		all necessary information, data and content is provided by
		Customer. Customer shall be responsible for all integration into
		the Customer App, including the cost of all integration. No use of
		the SDK shall be made by any third party (including the third-party
		app provider), all use of the SDK must be in accordance with the terms of this Agreement, and no integration shall occur, without CUE Audio’s
		approval and an agreement between the third-party and CUE Audio
		addressing such use.</FONT></FONT></P>
	</OL>
</OL>
<P  ALIGN=JUSTIFY class="margin-bottom-0"><BR>
</P>
<P  class="margin-bottom-17--border-none--padding-0--line-height-107">
<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">The
Fees for the Services shall be as set forth or agreed to in the
applicable Web Order, SO or SOW. The Fees for some additional
services are set forth below.</FONT></FONT></P>
<P  ALIGN=JUSTIFY class="margin-bottom-17--border-none--padding-0--line-height-107">
<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><B>1.	</B></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Changes
to Engagement Services</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
Any resizing or editing of Customer images will be billed at an
hourly rate of $250 per each hour or portion thereof. Additional
Customer requested audio files (up to 2 1/2 minutes in duration) with
corresponding light show design will be provided the rate of $750 or
otherwise as set forth in the Web Order, SO or SOW.</FONT></FONT></P>
<P  ALIGN=JUSTIFY class="margin-bottom-17--border-none--padding-0--line-height-107">
<FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><B>2.	</B></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt"><U><B>Technical
Support</B></U></FONT></FONT><FONT FACE="Calibri, serif"><FONT SIZE=2 class="font-size-11pt">.
For Technical Support requested by Customer beyond that covered in
the Agreement, Customer agrees to pay to CUE Audio an hourly rate of
$250 per each hour or portion thereof of technical support provided
by CUE Audio for all instances that require more than thirty (30)
minutes of technical support delivered by CUE.</FONT></FONT></P>

<p>If you have any questions about these Terms, please contact us.</p>
  </div>
  <div>
    <button (click)="accept()" class="btn btn-primary">Accept</button>
    <button (click)="cancel()" style="margin-left: 15px;" class="btn btn-danger">Decline</button>
  </div>
</div>